import { defaultApp, routeMap, type AppTarget } from "./index";

/** Check whether a base URL string is a valid absolute URL with a protocol. */
export function isValidBaseUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

/**
 * Determine which app owns the given path.
 * Matches entries in order; first match wins. Falls back to defaultApp.
 */
export function resolveApp(path: string): AppTarget {
  const normalized = path === "/" ? "/" : path.replace(/\/+$/, "");

  for (const entry of routeMap) {
    if (entry.pattern.endsWith("/**")) {
      const prefix = entry.pattern.slice(0, -3);
      if (normalized === prefix || normalized.startsWith(prefix + "/")) {
        return entry.app;
      }
    } else {
      if (normalized === entry.pattern) {
        return entry.app;
      }
    }
  }

  return defaultApp;
}
